// extracted by mini-css-extract-plugin
module.exports = {"title":"Error_title__nvV07 LoginPage_title__3dyGA components_pageTitle__B1wN3 components_pageTitle__B1wN3","fullWidth":"Error_fullWidth__2Ovny LoginPage_fullWidth__1e9gK"};